"use client";

import { Column } from "@faire/web/slate/Layout/Column";
import { useState } from "react";

import { SDUICarouselContext } from "./__internal__/SDUICarouselContext";

export const SDUICarouselRendererWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isNavigationEnabled, setIsNavigationEnabled] = useState(true);
  return (
    <SDUICarouselContext.Provider
      value={{ isNavigationEnabled, setIsNavigationEnabled }}
    >
      <Column data-test-id="carousel-renderer">{children}</Column>
    </SDUICarouselContext.Provider>
  );
};
